module.exports = __webpack_public_path__ + "img/bgc.f390a8cd.png";